import ModalBlocked from "../components/modal/modal-blocked";
import { apiFetch } from "./api-fetch";
import Toast from "../components/modal/toast";
import { onDomReady } from "../services/on-dom-ready";

let initPopup = popup => {

}

let getEmailPopupPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
      let element = document.getElementById("get-email");
      if (element) {
        let popup = ModalBlocked.get(element);
      
        let form = popup.root.querySelector("#get-email-form");
        let submit = form.querySelector('[type="submit"]');
        let request = popup.root.querySelector('.get-email__request');
        let confirm = popup.root.querySelector('.get-email__confirm');
        let confirmMail = confirm.querySelector('[data-mail]');

        const resetPopup = () => {
          form.reset();
          request.classList.remove('hidden');
          confirm.classList.add('hidden');
        }

        const showConfirm = (mail) => {
          if (confirmMail) confirmMail.textContent = mail;

          request.classList.add('hidden');
          confirm.classList.remove('hidden');
        }

        const startLoading = () => {
          submit.disabled = true;
          submit.setAttribute("data-loading", "");
        }

        const stopLoading = () => {
          submit.disabled = false;
          submit.removeAttribute("data-loading");
        }

        form.onsubmit = (e) => {
          e.preventDefault();
          
          let data = new FormData(form);
          if (!data.get('mail')) return;

          startLoading();
          apiFetch(form.action, {
            method: "POST",
            body: data
          })
          .then(result => {
            stopLoading();
            if (result.success) {
              showConfirm(data.get('mail'));
            } else {
              if (result.error) {
                Toast.open(result.error, {
                  state: "error"
                });
              }
            }
          })
          .catch(err => {
            stopLoading();
            console.error(err);
          })
        }

        resolve({
          reset: () => resetPopup(),
          open: () => popup.open()
        });
      } else {
        reject("There is no #get-email element on page");
      }
    });
});



const getEmail = () => {
  getEmailPopupPromise.then(popup => {
    popup.reset();
    popup.open();
  })
}

export { getEmail };